export default {
    en: require("./en"),
    zh: require("./zh"),
};
